import { listLogsEndpoint } from './logs/logsApi'
import { listMapsLocationEndpoint } from './maps/mapsApi'

const apis = {
  // Logs
  listLogsEndpoint,

  // Maps
  listMapsLocationEndpoint
}

export default apis
